import { useMutation } from "@tanstack/react-query";
import { API_URL } from "../../../../services/constant";

const useInitiateStaxPayment = () => {

    const mutation = useMutation({
        mutationFn: async (payload) => {
            let accessToken = JSON.parse(localStorage.getItem('accessToken'));
            const response = await fetch(
                `${API_URL}/payments/stax/create_payment_intent/`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        'Authorization': `Bearer ${accessToken}`
                    },
                    body: JSON.stringify(payload),
                }
            );

            const data = await response.json();

            if (!response.ok) {
                throw new Error(
                    data?.message || "Failed to initiate Stax payment"
                );
            }

            return data;
        },
    });

    return {
        isPaying: mutation.isPending,
        isPayed: mutation.isSuccess,
        isPaymentError: mutation.isError,
        paymentError: mutation.error,

        initiateStaxPayment: mutation.mutate,
        initiateStaxPaymentAsync: mutation.mutateAsync,

        paymentResponse: mutation.data,
    };
};

export default useInitiateStaxPayment;